<template>
    <v-timeline> 
        <v-timeline-item v-for="n in projectSteps" :key="n.i" :icon="n.icon" color="primary" large >
            <template v-slot:opposite>
                <span>
                    <h2>
                    {{n.name}}
                    </h2>
                </span>
            </template>
            <v-card class="elevation-2">
                <v-card-text>
                    {{n.description}}   
                </v-card-text>
            </v-card>
        </v-timeline-item>
    </v-timeline>
</template>

<script>
export default {
    name: "Projectoverview",
    data () {
        return {
            projectSteps: [
                {i: 1, name: "Ingestion", icon: "save_alt",description: "25 Million messages are ingested an hour from RouteViews - an open source which gives us access to messages from 200+ ASNs - and signed up CSPS"},
                {i: 2, name: "Triage", icon: "filter_list", description: "Duplicate messages are removed and messages are tagged with basic analytics i.e type of message"},
                {i: 3, name: "Analytics Engine", icon: "search", description: "A series of analytics are run on the event and a Hijack and Impact Score are calculated "},
                {i: 4, name: "Scored Event Creation", icon: "event", description: "Events are created which are processed/scored versions of BGP messages with meta-data tags"},
                {i: 5, name: "Scored Episode Creation", icon: "group_work", description: "Events with the same basic data (see glossary) are grouped based on 5 minute time slot, scores are aggregated and these are stored"},
                {i: 6, name: "User ASN Cross Reference", icon: "book", description: "All events which come through are cross-referenced with the ASNs which users are interested and if they are contained within this list they are parsed to the notification engine"},
                {i: 7, name: "Email Notification", icon: "notification_important", description: "An Email notification is sent out with the event in question"},
                {i: 8, name: "Validation Email Notification", icon: "add_alert", description: "Instead of sending out an email everytime we see the event, messages pertaining to the same ASN/Prefix combo are used to calculate a Validation score and when this breaches the user defined threshold a follow up email is sent."},
                {i: 9, name: "User Interaction on Web UI", icon: "explore",description: "The user can access the UI to find further information regarding the alert and gain an insight using visualisations, allowing the user to react to the event with a good understanding of the bigger picture"},
            ]
        }
    }
}
</script>

